import { render } from "./ManageUser.vue?vue&type=template&id=8a3d4890"
import script from "./ManageUser.vue?vue&type=script&lang=js"
export * from "./ManageUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__